export default __webpack_public_path__ + "static/media/362.17806021.jpg";